import React from 'react'
import {GLOBAL_IMAGES, Buttons } from "../../assets/asset";

const AIModal = ({ isOpen, onClose, onGetStarted }) => {
  const messages = [
    "Hello, Math Explorer! 👋",
    "Welcome to Math Adventure Land! 🎉 Get ready to solve fun math problems popping up as you explore. Each challenge helps you become a math whiz! Ready to test your skills and have fun with numbers? Let's see how many you can conquer!"
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div 
        className="relative w-[90%] max-w-3xl rounded-3xl overflow-hidden"
        style={{
          backgroundImage: `url(${GLOBAL_IMAGES.AiPopupBG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
        }}
      >
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 z-10"
        >
          <img src={Buttons.cross} alt="Close" className="w-10 h-10" />
        </button>

        <div className="p-6 pt-10 pb-16 h-full flex flex-col">
          <div className="flex-grow overflow-y-auto" style={{ minHeight: '280px' }}>
            <div className="flex items-start gap-3 mb-4">
              <img src={GLOBAL_IMAGES.progressReportImage} alt="AI" className="w-12" />
              <div className="bg-[#f5f0e6] rounded-2xl p-4" style={{ minHeight: '60px', width: '80%' }}>
                <p className="font-mali font-medium">{messages[0]}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 mb-8">
              <img 
                src={GLOBAL_IMAGES.progressReportImage} 
                alt="AI" 
                className="w-12" 
              />
              <div 
                className="bg-[#f5f0e6] rounded-2xl p-4"
                style={{ 
                  minHeight: '120px',
                  width: '80%'
                }}
              >
                <p className="font-mali font-medium">
                  {messages[1]}
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-auto">
            <button 
              onClick={onGetStarted}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 px-8 rounded-full transition-colors"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AIModal
